import React from 'react';
import { MapPin, Clock, ShieldCheck } from 'lucide-react';
import { CyberCard } from './ui/CyberCard';
export function Location() {
  return <section id="location" className="py-24 bg-cyber-black relative" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-93">
          {/* Info Column */}
          <div className="space-y-8" data-id="element-94">
            <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-white" data-id="element-95">
              <span className="text-cyber-pink" data-id="element-96">PHYSICAL</span> ACCESS
            </h2>

            <CyberCard glowColor="pink" className="p-8" data-id="element-97">
              <div className="flex items-start gap-4" data-id="element-98">
                <MapPin className="w-8 h-8 text-cyber-pink flex-shrink-0 mt-1" data-id="element-99" />
                <div data-id="element-100">
                  <h3 className="text-xl font-orbitron text-white mb-2" data-id="element-101">
                    Coordinates
                  </h3>
                  <p className="text-2xl font-rajdhani font-bold text-cyber-cyan mb-1" data-id="element-102">
                    10-14 Lonsdale Rd
                  </p>
                  <p className="text-xl font-rajdhani text-gray-400" data-id="element-103">
                    London NW6 6RD
                  </p>
                </div>
              </div>
            </CyberCard>

            <CyberCard glowColor="purple" className="p-8" data-id="element-104">
              <div className="flex items-start gap-4" data-id="element-105">
                <Clock className="w-8 h-8 text-cyber-purple flex-shrink-0 mt-1" data-id="element-106" />
                <div data-id="element-107">
                  <h3 className="text-xl font-orbitron text-white mb-2" data-id="element-108">
                    Operation Cycles
                  </h3>
                  <div className="space-y-2 font-rajdhani text-lg text-gray-300" data-id="element-109">
                    <div className="flex justify-between w-full max-w-xs" data-id="element-110">
                      <span data-id="element-111">Mon - Thu:</span>
                      <span className="text-cyber-green" data-id="element-112">10:00 - 00:00</span>
                    </div>
                    <div className="flex justify-between w-full max-w-xs" data-id="element-113">
                      <span data-id="element-114">Fri - Sat:</span>
                      <span className="text-cyber-green" data-id="element-115">10:00 - 04:00</span>
                    </div>
                    <div className="flex justify-between w-full max-w-xs" data-id="element-116">
                      <span data-id="element-117">Sunday:</span>
                      <span className="text-cyber-green" data-id="element-118">12:00 - 22:00</span>
                    </div>
                  </div>
                </div>
              </div>
            </CyberCard>
          </div>

          {/* Visual/Map Placeholder */}
          <div className="relative h-full min-h-[400px] rounded-lg overflow-hidden border border-cyber-cyan/30 bg-cyber-dark/50 p-2" data-id="element-119">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1478760329108-5c3ed9d495a0?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-20 filter grayscale contrast-125" data-id="element-120" />
            <div className="absolute inset-0 bg-cyber-cyan/10 mix-blend-overlay" data-id="element-121" />

            {/* HUD Overlay */}
            <div className="absolute inset-0 p-8 flex flex-col justify-between" data-id="element-122">
              <div className="flex justify-between items-start" data-id="element-123">
                <div className="font-orbitron text-xs text-cyber-cyan border border-cyber-cyan px-2 py-1" data-id="element-124">
                  SECURE SECTOR
                </div>
                <ShieldCheck className="w-6 h-6 text-cyber-cyan animate-pulse" data-id="element-125" />
              </div>

              <div className="self-center text-center" data-id="element-126">
                <div className="w-32 h-32 rounded-full border-2 border-dashed border-cyber-pink animate-[spin_10s_linear_infinite] flex items-center justify-center mx-auto mb-4" data-id="element-127">
                  <div className="w-24 h-24 rounded-full border border-cyber-cyan flex items-center justify-center" data-id="element-128">
                    <div className="w-2 h-2 bg-white rounded-full animate-ping" data-id="element-129" />
                  </div>
                </div>
                <p className="font-orbitron text-cyber-white tracking-widest text-sm" data-id="element-130">
                  SCANNING AREA...
                </p>
              </div>

              <div className="font-mono text-xs text-cyber-green" data-id="element-131">
                LAT: 51.5362° N<br data-id="element-132" />
                LNG: 0.2045° W
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}